import React from "react";
import { Topbar } from "@components";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Title,
  BoxText,
  BoxTitle,
  BoxWrapper,
  RootContainer,
  ListWrapper,
  Item,
  ItemText,
  LightText,
  DateText,
  SpinWrapper,
  EmptyText,
} from "./BonusHistory.style";
import { useEffect } from "react";
import { useState } from "react";
import { api } from "@api";
import moment from "moment";
import { getFormattedNumber, localStorage } from "@utils";
import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { saveUser } from "@redux/auth/authSlice";
import { useTranslation } from "react-i18next";

const dateFormat = "DD MMMM YYYY hh:mm A";

const BonusHistory = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { main_balance, bonus } = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getBonusHistory();

    // eslint-disable-next-line
  }, []);

  const getBonusHistory = () => {
    setLoading(true);
    api
      .getBonusHistory()
      .then(({ bonus_histories, user }) => {
        setLoading(false);
        setData(bonus_histories);

        // Save user to redux
        dispatch(saveUser(user));
        // Set user to localstorage
        localStorage.setUser(user);
      })
      .catch(() => {});
  };

  const goBack = () => {
    navigate(-1);
  };

  const renderTop = () => (
    <>
      <Box>
        <BoxTitle>{t("wallet.walletTotalBalance")}</BoxTitle>
        <BoxText>{`${getFormattedNumber(main_balance + bonus)} Ks`}</BoxText>
      </Box>
      <BoxWrapper>
        <Box>
          <BoxTitle>{t("wallet.actualTopBalance")}</BoxTitle>
          <BoxText color="light">{`${getFormattedNumber(
            main_balance
          )} Ks`}</BoxText>
        </Box>
        <Box>
          <BoxTitle>{t("wallet.bonusBalance")}</BoxTitle>
          <BoxText color="light">{`${getFormattedNumber(bonus)} Ks`}</BoxText>
        </Box>
      </BoxWrapper>
    </>
  );

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  return (
    <>
      <Topbar title={t("wallet.bonusHistoryTitle")} goBack={goBack} />
      <RootContainer>
        {renderTop()}
        <ListWrapper>
          <Title>{t("wallet.activeBonus")}</Title>
          {data.map((item, key) => (
            <Item key={key}>
              <ItemText>{`+${getFormattedNumber(item.amount)} Ks`}</ItemText>
              <LightText>
                {t("wallet.bonusHistoryLabel", {
                  amount: item.amount,
                  bonus_type: item.bonus_type,
                })}
              </LightText>
              <DateText status={item.is_bonus_expired ? "expired" : "default"}>
                {`${t("wallet.bonusHistoryExpired")}: ${moment
                  .unix(item.bonus_expired)
                  .format(dateFormat)}`}
              </DateText>
            </Item>
          ))}
          {loading && <Loader />}
          {!loading && data.length === 0 && (
            <EmptyText>{t("common.noRecord")}</EmptyText>
          )}
        </ListWrapper>
      </RootContainer>
    </>
  );
};

export default BonusHistory;
